import React, { Fragment } from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { graphql, StaticQuery } from 'gatsby'
import FormControl from '@material-ui/core/FormControl'
import Select from '@/components/common/Select'
import * as MenuItem from '@/components/common/MenuItem'
import Typography from '@/components/common/Typography'
import GhostButton from '@/components/common/GhostButton'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import WithStylesProps from '@/hoc/WithStylesProps'
import { desktop, laptop, tabletL, tabletS, mobile } from '@/utils/media'
import { mq } from '@/utils/helpers'
import Section from '@/components/common/Section'
import ProjectCard from './Card'

class ProjectList extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      clientType: '',
      platforms: '',
      stack: '',
      display: 24
    }
  }
  handleSelectChange = (event) => {
    this.setState({ [event.target.name]: event.target.value, display: 24 })
    event.currentTarget.blur()
  }
  handleClickMore = (event) => {
    this.setState({
      display: this.state.display + 24
    })
  }
  render () {
    return <StaticQuery
      query={query}
      render={ data => {
        const projects = data.allProjectListYaml.edges.map(el => el.node).filter(project => {
          let result = true
          if (this.state.clientType.length && project.clientType !== this.state.clientType) {
            result = false
          }
          if (this.state.platforms.length && (!project.platforms || project.platforms.indexOf(this.state.platforms) === -1)) {
            result = false
          }
          if (this.state.stack.length && (!project.stack || project.stack.indexOf(this.state.stack) === -1)) {
            result = false
          }
          return result
        }).reverse()
        const clientTypes = data.allProjectClientTypeYaml.edges.map(el => el.node)
        const platforms = data.allProjectTypeYaml.edges.map(el => el.node)
        const stacks = data.allProjectStackYaml.edges.map(el => el.node)
        const { classes } = this.props
        return (
          <Root>
            <Section
              title="その他の開発実績"
              body={(
                <Link
                  theme={this.props.theme}
                  href="https://drive.google.com/open?id=1ISUy-QIzMAMsh2-yhBW3oDrUg5R7FX3_EF2JVBgghXc"
                  target="_blank"
                  rel="noopener noreferrer">
                  スプレッドシートで見る
                </Link>
              )}
              bodyProps={{
                variant: 'h5',
                component: 'p'
              }}
              styles={styles.Section}
            >
              <Filters>
                <Filters_Child>
                  <Filter>
                    <Select
                      value={this.state.clientType}
                      onChange={this.handleSelectChange}
                      displayEmpty
                      inputProps={{
                        name: 'clientType',
                        id: 'clientType'
                      }}
                    >
                      <MenuItem.default value="" classes={{ ...MenuItem.get(classes) }}><Default>業種</Default></MenuItem.default>
                      {clientTypes.map((clientType, index) => (
                        <MenuItem.default key={index} value={clientType.name} classes={{ ...MenuItem.get(classes) }}>{clientType.name}</MenuItem.default>
                      ))}
                    </Select>
                  </Filter>
                </Filters_Child>
                <Filters_Child>
                  <Filter>
                    <Select
                      value={this.state.platforms}
                      onChange={this.handleSelectChange}
                      displayEmpty
                      inputProps={{
                        name: 'platforms',
                        id: 'platforms'
                      }}
                    >
                      <MenuItem.default value="" classes={{ ...MenuItem.get(classes) }}><Default>アプリケーション種別</Default></MenuItem.default>
                      {platforms.map((platforms, index) => (
                        <MenuItem.default key={index} value={platforms.name} classes={{ ...MenuItem.get(classes) }}>{platforms.name}</MenuItem.default>
                      ))}
                    </Select>
                  </Filter>
                </Filters_Child>
                <Filters_Child>
                  <Filter>
                    <Select
                      value={this.state.stack}
                      onChange={this.handleSelectChange}
                      displayEmpty
                      inputProps={{
                        name: 'stack',
                        id: 'stack'
                      }}
                    >
                      <MenuItem.default value="" classes={{ ...MenuItem.get(classes) }}><Default>言語・ツール</Default></MenuItem.default>
                      {stacks.map((stack, index) => (
                        <MenuItem.default key={index} value={stack.name} classes={{ ...MenuItem.get(classes) }}>{stack.name}</MenuItem.default>
                      ))}
                    </Select>
                  </Filter>
                </Filters_Child>
              </Filters>
              {projects.length > 0 && (
                <Fragment>
                  <List>
                    {projects.slice(0, this.state.display).map((project, index) => (
                      <List_Child key={index}><Card {...project} component="li" /></List_Child>
                    ))}
                  </List>
                  {projects.length > this.state.display && (
                    <More>
                      <More_Button onClick={this.handleClickMore}>もっと見る</More_Button>
                    </More>
                  )}
                </Fragment>
              )}
              {projects.length <= 0 && (
                <NoData>
                  <NoData_Title variant="h1" lang="en" component="h5" scale={500}>NO DATA</NoData_Title>
                  <NoData_Message variant="body1" scale={500}>条件と一致するデータが見つかりませんでした。</NoData_Message>
                </NoData>
              )}
            </Section>
          </Root>
        )
      }}
    />
  }
}

const Root = styled.div`
`

const Link = styled.a`
  color: ${props => props.theme.primary.light};
  text-decoration: underline;
`

const Filters = styled.div`
  @media ${mq.and(desktop, laptop, tabletL, tabletS)} {
    display: flex;
    margin: 0 -8px;
  }
  @media ${mq.and(mobile)} {
    margin-top: -8px;
  }
`

const Filters_Child = styled.div`
  @media ${mq.and(desktop, laptop, tabletL, tabletS)} {
    width: ${100 / 3}%;
    padding: 0 8px;
  }
  @media ${mq.and(mobile)} {
    margin-top: 8px;
  }
`

const Filter = styled(FormControl)`
  width: 100%;
`

const Default = styled.em`
  font-weight: bold;
`

const List = styled.ul`
  @media ${mq.and(desktop, laptop, tabletL, tabletS)} {
    display: flex;
    flex-wrap: wrap;
    margin: 44px -8px 0;
  }
  @media ${mq.and(mobile)} {
    margin-top: 32px;
  }
`

const List_Child = styled.li`
  margin-top: 16px;
  @media ${mq.and(desktop, laptop, tabletL)} {
    width: ${100 / 3}%;
    padding: 0 8px;
  }
  @media ${mq.and(tabletS)} {
    width: 50%;
    padding: 0 8px;
  }
`

const Card = styled(ProjectCard)`
  height: 100%;
`

const NoData = styled.div`
  margin-top: 80px;
  text-align: center;
  @media ${mq.and(mobile)} {
    margin-top: 40px;
  }
`

const NoData_Title = styled(Typography)`
  @media ${mq.and(mobile)} {
    font-size: 56px;
  }
`

const NoData_Message = styled(Typography)`
  margin-top: 16px;
`

const More = styled.div`
  margin-top: 40px;
  text-align: center;
  @media ${mq.and(mobile)} {
    margin-top: 24px;
  }
`

const More_Button = styled(GhostButton)`
  width: 180px;
`

const styles = {
  Section: {
    title: css`
      text-align: center;
    `,
    body: css`
      text-align: center;
      margin-top: 20px;
    `
  }
}

const query = graphql`
  query ProjectListQuery {
    allProjectListYaml {
      edges {
        node {
          clientType
          title
          platforms
          stack
          description
        }
      }
    }
    allProjectClientTypeYaml {
      edges {
        node {
          name
        }
      }
    }
    allProjectTypeYaml {
      edges {
        node {
          name
        }
      }
    }
    allProjectStackYaml {
      edges {
        node {
          name
        }
      }
    }
  }
`

const make = props => {
  return {
    ...MenuItem.make(props)
  }
}

export default ThemeConsumer(WithStylesProps(make)(ProjectList))
